import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [verifying, setVerifying] = useState(true);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (sessionId) {
      verifyPayment();
    }
  }, [sessionId]);

  const verifyPayment = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${API}/subscription/checkout-status/${sessionId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success && response.data.status === 'paid') {
        setSuccess(true);
      }
    } catch (error) {
      console.error('Verification failed:', error);
    } finally {
      setVerifying(false);
    }
  };

  if (verifying) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <RefreshCw className="w-16 h-16 text-blue-600 animate-spin mx-auto mb-4" />
          <p className="text-xl text-gray-600">Verifying your payment...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-blue-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl p-12 max-w-2xl w-full text-center">
        <CheckCircle className="w-24 h-24 text-green-500 mx-auto mb-6" />
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Payment Successful! 🎉
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          Welcome to DigiDreamSolutions Pro! Your subscription is now active.
        </p>
        
        <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
          <p className="text-green-800 font-semibold mb-2">What happens next?</p>
          <ul className="text-left text-green-700 space-y-2">
            <li>✓ Your account has been upgraded</li>
            <li>✓ All premium features are now unlocked</li>
            <li>✓ You'll receive a confirmation email shortly</li>
          </ul>
        </div>

        <div className="flex gap-4 justify-center">
          <Button
            onClick={() => navigate('/subscription')}
            className="bg-blue-600 hover:bg-blue-700 px-8 py-6 text-lg"
          >
            View Subscription Dashboard
          </Button>
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="px-8 py-6 text-lg"
          >
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
